import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fe5db2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-window" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "企画検索", -1))
const _hoisted_5 = { class: "form_group1" }
const _hoisted_6 = { class: "seachArea" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "seachText" }, "検索条件", -1))
const _hoisted_8 = { class: "search_checkbox" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "企画中止を含む", -1))
const _hoisted_10 = { class: "paging_container" }
const _hoisted_11 = { class: "kikakuTable" }
const _hoisted_12 = { class: "modalTable" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "common_th" }, "選択"),
    /*#__PURE__*/_createElementVNode("th", { class: "common_th" }, "企画ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "common_th" }, "タイトル"),
    /*#__PURE__*/_createElementVNode("th", { class: "common_th" }, "企画担当者")
  ])
], -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]

import axios from "axios";
import { onMounted, ref } from "vue";
import Paginate from "vuejs-paginate-next";
import { useStore } from "vuex";
import ModalRyuyoDetails from "./ModalRyuyoDetails.vue";

// 初期設定関連--------------------------------------------------
type KikakuData = {
  hanmotoCd: string;
  userId: number;
  userName: string;
  kikakuId: number;
  kikakuMei: string;
  kikakuMeiKana: string;
  syohinKbnId: number;
  syohinKbn: string;
  syohinBunruiId: number;
  syohinBunrui: string;
  hannyuKiboYearAndMonth: string;
  kariSiyo: string | null;
  version: number | null;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalRyuyo',
  setup(__props) {

const store = useStore();

// 企画詳細モーダル-----------------------------------------------
const kikakuDetailVisible = ref(false);
const selectedKikakuId = ref();
const openKikakuDetailModal = (kikakuId: any) => {
  selectedKikakuId.value = kikakuId; // 選択されたkikakuIdを保存
  kikakuDetailVisible.value = true;
};

// 企画検索--------------------------------------------------------
// 検索条件
const freeword = ref("");
const isContainsCancel = ref(false);
// 検索結果データ
const kikakuData = ref([] as KikakuData[]);
const getKikakuData = async () => {
  try {
    kikakuData.value.splice(0);
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/kikaku/?freeword=${freeword.value}&containsCancel=${isContainsCancel.value}&page=${currentPage.value}&numberOfDisplay=${dataPerPage}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    kikakuData.value = res.data.display;
    numberOfTotalData.value = res.data.size;
    firstCount.value = res.data.firstCount;
    finalCount.value = res.data.finalCount;
    getTotalPage();
  } catch (error) {
    alert("企画データを取得できませんでした");
  }
};
onMounted(() => {
  getKikakuData();
});

// ページネーション関連処理-----------------------------------------
// 取得データ合計
let numberOfTotalData = ref(0);
// 1ページあたりの表示データ数(一旦固定)
let dataPerPage = 100;
//表示中のページ範囲
let firstCount = ref(0);
let finalCount = ref(0);
// 総ページ数
const numberOfTotalPage = ref(0);
// 現在のページ数
const currentPage = ref(1);
const getTotalPage = () => {
  numberOfTotalPage.value = Math.ceil(numberOfTotalData.value / dataPerPage);
};
const onClickPage = (newPage: number) => {
  currentPage.value = newPage;
  getKikakuData();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "modal",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "modal modal-overlay",
        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$emit('closeModal')), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      class: "text_box",
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((freeword).value = $event)),
                      placeholder: "企画名のキーワードを入力"
                    }, null, 512), [
                      [_vModelText, freeword.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isContainsCancel).value = $event))
                    }, null, 512), [
                      [_vModelCheckbox, isContainsCancel.value]
                    ])
                  ]),
                  _createElementVNode("div", { class: "btn_green" }, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: getKikakuData
                    }, "検索")
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_unref(Paginate), {
                    "page-count": numberOfTotalPage.value,
                    "hide-prev-next": true,
                    "page-range": 3,
                    "prev-text": '<',
                    "next-text": '>',
                    "container-class": 'pagination',
                    "page-class": 'page-item',
                    "page-link-class": 'page-item--link',
                    "active-class": 'page-item--active',
                    "click-handler": onClickPage,
                    "force-page": currentPage.value
                  }, null, 8, ["page-count", "force-page"])
                ]),
                _withDirectives(_createElementVNode("span", { class: "paging_result" }, " 検索結果：" + _toDisplayString(_unref(numberOfTotalData)) + "件/" + _toDisplayString(_unref(firstCount)) + "～" + _toDisplayString(_unref(finalCount)) + "件を表示", 513), [
                  [_vShow, kikakuData.value.length]
                ]),
                _withDirectives(_createElementVNode("span", null, "検索結果がありません", 512), [
                  [_vShow, !kikakuData.value.length]
                ])
              ]),
              (kikakuDetailVisible.value)
                ? (_openBlock(), _createBlock(ModalRyuyoDetails, {
                    key: 0,
                    onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (kikakuDetailVisible.value = false)),
                    selectId: selectedKikakuId.value,
                    class: "modal"
                  }, null, 8, ["selectId"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("table", _hoisted_12, [
                  _hoisted_13,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kikakuData.value, (kikaku, index) => {
                    return (_openBlock(), _createElementBlock("tbody", { key: index }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.$emit('child-event', kikaku.kikakuId)),
                            class: "btn_green_small"
                          }, "選択", 8, _hoisted_14)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(kikaku.kikakuId), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (openKikakuDetailModal(kikaku.kikakuId))
                          }, _toDisplayString(kikaku.kikakuMei), 9, _hoisted_15)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(kikaku.userName), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('closeModal')))
              }, "とじる")
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})